import config from '@/config/env-constants';


function getDefaultCompanyObj() {
    return {
        name: '',
        description: '',
        type: null,
        industry: null,
        industryOthers: null,
        hasParentCompany: false,
        parentCompany: '',
        parentCompanyId: '',
        isActive: 'true',

        address: '',
        geoaddress: {
            latitude: 0.0,
            longitude: 0.0,
        },

        contactPerson: '',
        contactNo: '',
        emailAddress: '',

        // subscriptions details
        brand: '',
        branchCode: '',
        noOfStorageLocations: 0,
        noOfInactiveNodes: 0,
        noOfUsers: 0,
        has2WayAuth: false,
        camera: { ...config.cameraDefaultValues },

        permissions: { ...config.permissionsDefaultValues },
        companyLogo: {},

        dateCreated: '',
        createdBy: '',
        dateUpdated: '',
        updatedBy: '',
    };
}

function cleanupFields(company) {
    let cleanedObj = { ...company };

    delete cleanedObj['status'];
    delete cleanedObj['Date Created'];
    delete cleanedObj['Date Updated'];
    delete cleanedObj['Has 2-Way Auth?'];
    delete cleanedObj['hasCameraTop'];
    delete cleanedObj['hasCameraBack'];
    delete cleanedObj['hasCms'];
    delete cleanedObj['hasInventory'];
    delete cleanedObj['hasDispatch'];
    delete cleanedObj['hasTransport'];
    delete cleanedObj['hasMaintenance'];
    delete cleanedObj['hasBilling'];
    delete cleanedObj['_showDetails'];

    return cleanedObj;
}

function hasAtLeast1Permission(company) {
    let permissions = company.permissions;
    return permissions.cms || permissions.inventory || permissions.dispatch
        || permissions.maintenance || permissions.transport;
}

export const CompanyUtil = {
    getDefaultCompanyObj,
    cleanupFields,
    hasAtLeast1Permission
}